import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Tabs, 
  Tab, 
  Box,
  useTheme
} from '@mui/material';
import {
  Person,
  Group,
  Groups as GroupsIcon
} from '@mui/icons-material';

const AdminNavigation = ({ currentPath }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  // Determine which tab should be active based on current path
  const getActiveTab = () => {
    if (currentPath.includes('/admin/user-management')) return 0;
    if (currentPath.includes('/admin/team-management')) return 1;
    if (currentPath.includes('/admin/team-groups-management')) return 2;
    return 0; // default to users tab
  };

  const handleTabChange = (event, newValue) => {
    // Navigate to the appropriate route based on tab selection
    switch (newValue) {
      case 0:
        navigate('/admin/user-management');
        break;
      case 1:
        navigate('/admin/team-management');
        break;
      case 2:
        navigate('/admin/team-groups-management');
        break;
      default:
        navigate('/admin/user-management');
    }
  };

  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <Tabs
        value={getActiveTab()}
        onChange={handleTabChange}
        aria-label="admin navigation tabs"
        variant="fullWidth"
        sx={{
          minHeight: 60,
          backgroundColor: 'background.paper',
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          border: `1px solid ${theme.palette.divider}`,
          '& .MuiTabs-indicator': {
            height: 3,
            borderRadius: '3px 3px 0 0',
            backgroundColor: theme.palette.primary.main,
          },
          '& .MuiTab-root': {
            minHeight: 60,
            textTransform: 'none',
            fontSize: '0.95rem',
            fontWeight: 500,
            color: theme.palette.text.secondary,
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.action.hover,
            },
            '&.Mui-selected': {
              color: theme.palette.primary.main,
              fontWeight: 600,
            },
          },
        }}
      >
        <Tab 
          icon={<Person sx={{ fontSize: 20 }} />} 
          label="Users" 
          id="admin-nav-tab-0"
          iconPosition="start"
        />
        <Tab 
          icon={<Group sx={{ fontSize: 20 }} />} 
          label="Teams" 
          id="admin-nav-tab-1"
          iconPosition="start"
        />
        <Tab 
          icon={<GroupsIcon sx={{ fontSize: 20 }} />} 
          label="Team Groups" 
          id="admin-nav-tab-2"
          iconPosition="start"
        />
      </Tabs>
    </Box>
  );
};

export default AdminNavigation; 